import Image1 from "../../assets/testimonial1.png";
import Image2 from "../../assets/testimonial2.png";
import Image3 from "../../assets/testimonial3.png";

export const Data = [
    {
      id: 1,
      image: Image1,
      title:"krupa Patel" ,
      description: "[HR manager at Tanna accounts] - Thank you for providing me accounting data using web scripting process. Your efforts are truly appreciated and have been immensely helpful. Your expertise and skill in this area are truly impressive. Once again, thank you very much shubham ."
       ,
    },
    {
      id: 2,
      image: Image2,
      title: "Jaimin Vachhani"  ,
      description:" [CEO - Akshar international]- You did a really good job. Thank you for taking our business online and ensuring that all aspects of the project were followed step by step, resulting in a high-quality website. Your attention to detail and technical expertise were greatly appreciated "
        ,
    },
    {
      id: 3,
      image: Image3,
      title: "Shyam Makawana",
      description:
      "[Co - Akshar international] - Thank you for your dedication, hard work, and commitment to delivering an outstanding website. I am thrilled with the end result and look forward to working with you again in the future..",
    },
  ];